import React from 'react';
import {Box, Button, Divider, Paper, Stack, Typography} from '@mui/material';
import {Sx} from 'app/types/common';
import {Icons} from 'app/util/icons';
import {Credits} from 'app/components/Settings/BillingAndUsage/PaymentInformation/Credits/Credits';
import {PaymentMethod} from 'app/components/Settings/BillingAndUsage/PaymentInformation/PaymentMethod/PaymentMethod';
import {Payment} from 'app/components/entities/billing/payment';

interface Props extends Sx {
  metadata: Payment.Metadata;
  onEnterCoupon: (coupon: string) => void;
  onEditPayment: () => void;
  onCancelRequest: () => void;
}

export function PaymentInformation({
  sx,
  metadata,
  onEnterCoupon,
  onEditPayment,
  onCancelRequest,
}: Props) {
  return (
    <Box sx={sx}>
      <Stack direction="row" gap={3} alignItems="center" mb={2}>
        <Typography variant="h5" fontWeight={600}>
          Payment information
        </Typography>

        <Button
          data-id="enter_coupon_button"
          variant="text"
          size="large"
          startIcon={Icons.coupon().reactComponent()}
          onClick={() => onEnterCoupon('')}
        >
          Enter a voucher code
        </Button>
      </Stack>

      <Paper variant="outlined">
        <Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
          <PaymentMethod
            sx={{flex: 1}}
            info={metadata.info}
            onEditPayment={onEditPayment}
            onCancelPending={onCancelRequest}
          />

          <Credits
            sx={{flex: 1}}
            balance={metadata.customer?.balance ?? 0}
            cardPayment={metadata.info?.paymentMethod === 'credit_card'}
          />
        </Stack>
      </Paper>
    </Box>
  );
}
